import React from "react";
import "./SeriesActionModal.css";

function SeriesActionModal({ eventTitle, onEditThis, onDeleteThis, onDeleteFollowing, onDeleteAll, onClose }) {
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("modal-overlay")) onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal series-action-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Recurring event</h2>
        <p className="series-event-title">{eventTitle}</p>

        <div className="series-actions">
          <button className="series-btn series-btn--primary" onClick={onEditThis}>
            Edit this event
          </button>
          <button className="series-btn series-btn--danger" onClick={onDeleteThis}>
            Delete this event
          </button>
          <button className="series-btn series-btn--danger" onClick={onDeleteFollowing}>
            Delete this &amp; all following
          </button>
          <button className="series-btn series-btn--danger-strong" onClick={onDeleteAll}>
            Delete entire series
          </button>
        </div>

        <div className="modal-footer-row">
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default SeriesActionModal;
